var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState } from "react";
import { Dialog } from "@headlessui/react";
import { useAuth0 } from "@auth0/auth0-react";
import { apiFetch, StyledButton, StyledButtonStyle, TextInput, } from "ee-react-components";
import { orchestratorUrl } from "./api";
var pad = function (n) { return String(n).padStart(2, "0"); };
/** Format a Date as a `datetime-local` value (`YYYY-MM-DDTHH:mm`) in local time. */
var toLocalInput = function (d) {
    return "".concat(d.getFullYear(), "-").concat(pad(d.getMonth() + 1), "-").concat(pad(d.getDate()), "T").concat(pad(d.getHours()), ":").concat(pad(d.getMinutes()));
};
/**
 * Manually fire a strategy over an operator-chosen window. The window is
 * entered in local time and sent to the API as UTC ISO strings; the backend
 * creates one event and dispatches schedules to every subscribed site.
 */
export var StrategyRunDialog = function (_a) {
    var _b, _c;
    var open = _a.open, strategy = _a.strategy, onClose = _a.onClose, onRan = _a.onRan;
    var getAccessTokenSilently = useAuth0().getAccessTokenSilently;
    var _d = useState(function () { return toLocalInput(new Date()); }), start = _d[0], setStart = _d[1];
    var _e = useState(function () {
        return toLocalInput(new Date(Date.now() + 60 * 60 * 1000));
    }), end = _e[0], setEnd = _e[1];
    var _f = useState(false), running = _f[0], setRunning = _f[1];
    var _g = useState(null), error = _g[0], setError = _g[1];
    var run = function () { return __awaiter(void 0, void 0, void 0, function () {
        var startDate, endDate, getToken, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setError(null);
                    if (!strategy)
                        return [2 /*return*/];
                    startDate = new Date(start);
                    endDate = new Date(end);
                    if (Number.isNaN(startDate.getTime()))
                        return [2 /*return*/, setError("Start is not a valid date/time.")];
                    if (Number.isNaN(endDate.getTime()))
                        return [2 /*return*/, setError("End is not a valid date/time.")];
                    if (endDate <= startDate)
                        return [2 /*return*/, setError("End must be after start.")];
                    if (endDate <= new Date())
                        return [2 /*return*/, setError("End must be in the future.")];
                    setRunning(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    getToken = function () {
                        return getAccessTokenSilently({
                            authorizationParams: { audience: process.env.AUTH0_AUDIENCE },
                        });
                    };
                    return [4 /*yield*/, apiFetch("".concat(orchestratorUrl(), "/strategies/").concat(strategy.id, "/run"), {
                            method: "POST",
                            body: {
                                startTimestamp: startDate.toISOString(),
                                endTimestamp: endDate.toISOString(),
                            },
                            callbacks: { getToken: getToken },
                        })];
                case 2:
                    _a.sent();
                    onRan();
                    onClose();
                    return [3 /*break*/, 5];
                case 3:
                    e_1 = _a.sent();
                    setError(e_1.message);
                    return [3 /*break*/, 5];
                case 4:
                    setRunning(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var siteCount = (_b = strategy === null || strategy === void 0 ? void 0 : strategy.subscribedSiteIds.length) !== null && _b !== void 0 ? _b : 0;
    return (React.createElement(Dialog, { open: open, onClose: onClose, className: "relative z-50" },
        React.createElement("div", { className: "fixed inset-0 bg-black/90", "aria-hidden": "true" }),
        React.createElement("div", { className: "fixed inset-0 flex items-center justify-center p-4" },
            React.createElement(Dialog.Panel, { className: "bg-black-1100 border border-black-700 shadow-2xl rounded-[16px] p-[32px] w-full max-w-[640px] max-h-[90vh] overflow-y-auto flex flex-col gap-y-[16px]" },
                React.createElement(Dialog.Title, { className: "text-white font-N6" },
                    "Run \u201C", (_c = strategy === null || strategy === void 0 ? void 0 : strategy.name) !== null && _c !== void 0 ? _c : "",
                    "\u201D"),
                React.createElement("p", { className: "text-black-400 font-N8" },
                    "Manually fires this strategy over the window below, creating one event and dispatching schedules to",
                    " ",
                    siteCount === 1
                        ? "1 subscribed site"
                        : "".concat(siteCount, " subscribed sites"),
                    ".",
                    siteCount === 0 &&
                        " No sites are subscribed, so no schedules will be created."),
                React.createElement("div", { className: "grid grid-cols-2 gap-[8px]" },
                    React.createElement(Field, { label: "Start", action: React.createElement(ShortcutButton, { onClick: function () { return setStart(toLocalInput(new Date())); } }, "Now") },
                        React.createElement(TextInput, { type: "datetime-local", className: "w-full text-white [color-scheme:dark]", value: start, onChange: function (e) { return setStart(e.target.value); } })),
                    React.createElement(Field, { label: "End", action: React.createElement(ShortcutButton, { onClick: function () {
                                return setEnd(toLocalInput(new Date(Date.now() + 60 * 60 * 1000)));
                            } }, "Now + 1 hr") },
                        React.createElement(TextInput, { type: "datetime-local", className: "w-full text-white [color-scheme:dark]", value: end, onChange: function (e) { return setEnd(e.target.value); } }))),
                error && React.createElement("div", { className: "text-red font-N8" }, error),
                React.createElement("div", { className: "flex flex-row justify-end gap-x-[8px]" },
                    React.createElement(StyledButton, { text: "Cancel", style: StyledButtonStyle.Gray, onClick: onClose }),
                    React.createElement(StyledButton, { text: running ? "Submitting..." : "Run", onClick: run, disabled: running }))))));
};
var Field = function (_a) {
    var label = _a.label, action = _a.action, children = _a.children;
    return (React.createElement("div", { className: "flex flex-col gap-y-[4px]" },
        React.createElement("div", { className: "flex flex-row items-center justify-between gap-x-[8px] min-h-[24px]" },
            React.createElement("span", { className: "text-black-400 font-N8" }, label),
            action),
        children));
};
var ShortcutButton = function (_a) {
    var onClick = _a.onClick, children = _a.children;
    return (React.createElement("button", { type: "button", onClick: onClick, className: "bg-black-1000 hover:bg-black-800 text-white font-N8 text-[12px] px-[10px] py-[4px] rounded-[6px]" }, children));
};
